import { Link } from 'react-router-dom';
import { MapPin, Phone, Smartphone, ArrowUpRight } from 'lucide-react';
import { assetUrl } from '@/lib/assetUrl';

export default function Footer() {
  return <footer className="clinic-footer" id="contato">
    <div className="clinic-container">
      <div className="footer-grid">
        <div className="footer-brand">
          <img src={assetUrl('/images/clinica-logo.png')} alt="Clínica de Ayurveda — Medicina Oriental" loading="lazy"/>
          <p>Um olhar integral para o corpo, a mente e a sua maneira de viver.</p>
        </div>
        <div><h3>Conheça a clínica</h3><a href="/#ayurveda">Sobre o Ayurveda</a><a href="/#medico">Dr. Aderson Moreira da Rocha Neto</a><a href="/#doshas">Os três doshas</a><a href="/#como-funciona">Como funciona</a></div>
        <div><h3>Sua jornada</h3><Link to="/acesso">Começar o questionário</Link><Link to="/minha-conta">Minha conta</Link><a href="/#faq">Perguntas frequentes</a></div>
        <div className="footer-contact">
          <h3>Visite a clínica</h3>
          <address>
            <div className="footer-address"><MapPin size={17}/><div><strong>CENTRO MÉDICO BARÃO DE LUCENA</strong><span>Rua Barão de Lucena 48 sala 17</span><span>Botafogo – Rio de Janeiro</span></div></div>
            <a href="tel:+552125373251"><Phone size={15}/> Telefone: (21) 2537-3251</a>
            <a href="tel:+5521982722070"><Smartphone size={15}/> Celular: (21) 98272-2070</a>
            <a className="footer-map" href="https://www.google.com/maps/search/?api=1&query=Rua%20Bar%C3%A3o%20de%20Lucena%2048%20Botafogo%20Rio%20de%20Janeiro" target="_blank" rel="noopener noreferrer">Ver localização no mapa <ArrowUpRight size={13}/></a>
          </address>
        </div>
      </div>
      <div className="footer-bottom"><span>© {new Date().getFullYear()} Clínica de Ayurveda. Todos os direitos reservados.</span><span>Conteúdo educativo. Não substitui uma avaliação médica.</span></div>
      <p className="developer-signature">Orgulhosamente desenvolvido por <a href="https://www.serraconsultoria.com" target="_blank" rel="noopener noreferrer">Serra Consultoria <ArrowUpRight size={12}/></a></p>
    </div>
  </footer>;
}
